import { createStore } from 'vuex';

const store = createStore({
    state() {
        return {
            planetsData: {},
            planetsList: [],
            screenInnerWidth: null
        };        
    },
    mutations: {
        setPlanetsData(state, data) {
            state.planetsData = data;
            for (let planet in data) {
                state.planetsList.push(planet);
            }
        },

        setScreenWidth(state, newWidth) {
            state.screenInnerWidth = newWidth;
        }
    },
    actions: {
        uploadPlanetsData(context, data) {
            context.commit('setPlanetsData', data);
        },

        updateScreenWidth(context, newWidth) {
            context.commit('setScreenWidth', newWidth);
        }
    },
    getters: {
        screenWidth: (state) => state.screenInnerWidth,
        isSmallScreen: (state) => state.screenInnerWidth < 768,
        isTabletScreen: (state) => state.screenInnerWidth >= 768,
        planetsList: (state) => state.planetsList,
        planetsData: (state) => state.planetsData
    }
});

export default store;